import { Link } from 'react-router-dom';

export function Forbidden() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gn-bg px-4">
      <div className="w-full max-w-md text-center">
        <h1 className="font-headline text-4xl font-bold text-gn-primary-forest">
          Acceso restringido
        </h1>
        <p className="mt-3 text-sm text-gn-ink/70">
          Esta sección solo está disponible para administradores. Si crees que
          deberías tener acceso, contacta con la persona que gestiona los roles
          del panel.
        </p>
        <Link to="/dashboard" className="gn-btn-primary mt-6 inline-flex">
          Volver al dashboard
        </Link>
      </div>
    </div>
  );
}
